import React from 'react';
import classNames from 'classnames';

/**
 * 견적서 하단 안내 문구 (SetConfirmEstimateDescription2 항목)
 * @param {string} text 표시 텍스트 (HTML 허용)
 * @param {string} [color] 16진수 색상 e.g. '#e53935'
 * @returns {string | { text: string, color: string }}
 */
export const estimateDescriptionLine = (text, color) => {
    if (color) {
        return { text, color };
    }
    return text;
};

export const resolveEstimateDescriptionItem = (item) => {
    if (typeof item === 'string') {
        return { html: item, color: undefined };
    }
    return {
        html: item.text,
        color: item.color,
    };
};

export const EstimateDescriptionListItem = ({ item }) => {
    const { html, color } = resolveEstimateDescriptionItem(item);
    return (
        <span
            className={classNames('grey-2')}
            style={color ? { color } : undefined}
            dangerouslySetInnerHTML={{ __html: html }}
        />
    );
};
